export default __webpack_public_path__ + "assets/pdf/FT_ZNEKu.32dfbf50.pdf";